import querystring from 'querystring';
import { toAltText } from './toAltText';
const WIX_IMAGE_PROTOCOL = 'wix:';
const WIX_LEGACY_IMAGE_PROTOCOL = 'image:';
const WIX_IMAGE_PROTOCOL_SUFFIX = 'image://v1/';
const URL_HASH_PREFIX = '#';
const DEFAULT_IMAGE_FILE_NAME = 'file';
const alignIfLegacyImage = (image) => {
    const { protocol } = new URL(image);
    return protocol === WIX_LEGACY_IMAGE_PROTOCOL ? `wix:${image}` : image;
};
const corvidToP13n = (image) => {
    if (!image) {
        return undefined;
    }
    const alignedImage = alignIfLegacyImage(image);
    const { protocol, hash, pathname } = new URL(alignedImage);
    const { originHeight: height, originWidth: width } = querystring.parse(hash.replace(URL_HASH_PREFIX, ''));
    const [id, filename] = pathname
        .replace(WIX_IMAGE_PROTOCOL_SUFFIX, '')
        .split('/');
    if (protocol === WIX_IMAGE_PROTOCOL) {
        return {
            id,
            height: Number(height),
            width: Number(width),
            altText: toAltText(filename),
        };
    }
    return { url: image };
};
const computeImageFileName = (image) => {
    const filename = image.altText ?? DEFAULT_IMAGE_FILE_NAME;
    return encodeURIComponent(filename);
};
const p13nToCorvid = (image) => {
    if (!image) {
        return undefined;
    }
    return image.id
        ? `wix:image://v1/${image.id}/${computeImageFileName(image)}#originWidth=${image.width}&originHeight=${image.height}`
        : image?.url;
};
export { corvidToP13n, p13nToCorvid };
//# sourceMappingURL=index.js.map